import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import BenefitsSection from './components/BenefitsSection';
import ComparisonSection from './components/ComparisonSection';
import SEOArticlesSection from './components/SEOArticlesSection';
import TrustSection from './components/TrustSection';
import CtaBanner from './components/CtaBanner';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main>
        {/* 1. Hero */}
        <HeroSection />

        {/* 2. Category Grid */}
        <CategoryGrid />

        {/* 3. Benefits */}
        <BenefitsSection />

        {/* 4. Comparison */}
        <ComparisonSection />

        {/* 5. Mid-page CTA with product strip */}
        <CtaBanner
          variant="primary"
          headline="Ready to Upgrade Your Shopping?"
          subheadline="Join thousands of smart shoppers using itaobuyspreadsheet to find better deals and make smarter decisions."
          buttonText="buy it now"
          buttonUrl="https://kaspreadsheet.com"
          showProductStrip={true}
        />

        {/* 6. SEO Articles */}
        <SEOArticlesSection />

        {/* 7. Trust */}
        <TrustSection />

        {/* 8. Final CTA */}
        <CtaBanner
          variant="secondary"
          headline="Start Using itaobuyspreadsheet Today"
          subheadline="Transform the way you shop online with the ultimate spreadsheet-based shopping system."
          buttonText="Access itaobuyspreadsheet System"
          buttonUrl="https://kaspreadsheet.com"
        />
      </main>

      <Footer />
    </div>
  );
}